import { render, staticRenderFns } from "./SectionDetails.vue?vue&type=template&id=78868212"
import script from "./SectionDetails.vue?vue&type=script&lang=js"
export * from "./SectionDetails.vue?vue&type=script&lang=js"
import style0 from "./SectionDetails.vue?vue&type=style&index=0&id=78868212&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports